

































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import SendedPorposalTableComponent from '@/components/proposal-table-research-centers/table.vue';
import { ProposalState } from '@/enums/ProposalState';

@Component({
  components : {
    SendedPorposalTableComponent
  }
})
export default class SendedPorposal extends GenericBTable<
  Annoucement
> {
  enviado: ProposalState = ProposalState.EnviadoCI;
  devuelto: ProposalState = ProposalState.DevueltoCI;
  rechazado: ProposalState = ProposalState.RechazadoCI;
  aprobado: ProposalState = ProposalState.EnviadoFC;
  devueltoFC: ProposalState = ProposalState.DevueltoFC;
}
